import { render, staticRenderFns } from "./ProductBrandEdit.vue?vue&type=template&id=ea8e853a&"
import script from "./ProductBrandEdit.vue?vue&type=script&lang=js&"
export * from "./ProductBrandEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports